import { LOVE_ROUTE_NAMES, LOVE_PREVIEW_KIND } from "@/apps/love/love.routes";
import { goToField } from "@/shared/utils";

export function useLoveGoTo() {
    return {
        goToRequestField(fieldId) {
            goToField(LOVE_ROUTE_NAMES.projectForm, LOVE_PREVIEW_KIND.mail, fieldId);
        },
        goToFormField(fieldId) {
            goToField(LOVE_ROUTE_NAMES.projectForm, LOVE_PREVIEW_KIND.form, fieldId);
        },
        goToWallField(fieldId) {
            goToField(LOVE_ROUTE_NAMES.projectWall, LOVE_PREVIEW_KIND.wall, fieldId);
        },
        goToTestimonialField(testimonialId, fieldId) {
            goToField(
                LOVE_ROUTE_NAMES.projectReviewsList,
                LOVE_PREVIEW_KIND.wall,
                fieldId,
                "edit",
                testimonialId
            );
        },
    };
}
